import { SidebarMenuBadge, Text } from "@salestrak/ui";

/**
 * A directory count on a module-menu row. It reads as ambient metadata, not
 * an attention signal like the inbox unread badge — muted ink, hidden at zero,
 * capped at 99+. A caller whose source is paged must keep its fetch limit
 * above the cap, or the display lies.
 */
export function SidebarCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <SidebarMenuBadge>
      <Text size="xs" color="muted">
        {count > 99 ? "99+" : count}
      </Text>
    </SidebarMenuBadge>
  );
}
